import { Helper, Input, Label } from "lumir-back-office-ui";
import DateForm from "./calendar/DateForm";
import { forwardRef } from "react";

const InputField = forwardRef(
  (
    {
      label,
      placeholder,
      type,
      rightIcon,
      error,
      onChange,
      value,
      disabled,
      ...props
    },
    ref
  ) => {
    const handleChange = (e) => {
      let newValue = e.target?.value ?? e;

      if (props.onChange) {
        props.onChange({
          target: {
            name: props.name,
            value: newValue,
          },
        });
      }

      if (onChange) {
        onChange({
          target: {
            name: props.name,
            value: newValue,
          },
        });
      }
    };

    const errorMessage = typeof error === "object" ? error.message : error;

    return (
      <div className="text-left space-y-[4px] relative">
        <Label>{label}</Label>
        {type === "date" ? (
          <DateForm
            value={value}
            onChange={handleChange}
            ref={ref}
            {...props}
          />
        ) : (
          <Input
            size="md"
            placeholder={placeholder}
            className="w-full h-[32px] rounded-md"
            value={value}
            onChange={handleChange}
            rightIcon={rightIcon}
            type={type}
            ref={ref}
            disabled={disabled}
            {...props}
          />
        )}
        {errorMessage && (
          <Helper
            size="md"
            state="error"
            className="typography-semantic-body-2-regular"
            message={errorMessage}
          />
        )}
      </div>
    );
  }
);

InputField.displayName = "InputField";

export { InputField };
